import React from "react";
import { Modal, MimaText, MimaButton, PageLoader } from "../../components";
import useDeletePaymentLinkLogic from "./useLogic/useDeletePaymentLinkLogic";

const DeletePaymentLink = ({ closeModal }) => {
  const { loading, confirmDelete, selectedLink } = useDeletePaymentLinkLogic({
    closeModal,
  });
  return (
    <Modal closeModal={closeModal}>
      {loading ? (
        <PageLoader title="Deactivation in progress" />
      ) : (
        <>
          <MimaText variant="subtitleBold" mb={2} align="center">
            Deactivate Payment Link
          </MimaText>
          <MimaText width={38} align="center" mb={2}>
            Are you sure you want to deactivate{" "}
            <span
              style={{
                fontWeight: "700",
                color: "var(--color-fash-primary-3)",
              }}
            >
              {selectedLink.title}
            </span>
          </MimaText>
          <div
            style={{
              display: "flex",
              width: "38rem",
              justifyContent: "space-between",
            }}
          >
            <MimaButton
              title="Yes, Deactivate"
              width={18}
              onClick={confirmDelete}
              variant="form"
            />
            <MimaButton
              title="No"
              buttonColor="var(--color-dark)"
              width={18}
              variant="form"
              onClick={closeModal}
            />
          </div>
        </>
      )}
    </Modal>
  );
};

export default DeletePaymentLink;
